export const getResponsePayload = (data) => {
  if (data?.data !== undefined) return data.data
  return data
}

export const getResponseList = (data) => {
  const payload = getResponsePayload(data)
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.data)) return payload.data
  return []
}
